"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { EmptyStateStack } from "../empty-state/EmptyState";
import { ActivityFeedSkeleton } from "./ActivityFeedSkeleton";
export function ActivityFeedEmptyState(t0) {
  const $ = _c(11);
  const {
    hasSearchParams,
    onResetFilters
  } = t0;
  const t = useTranslations("ActivityFeedEmptyState");
  let t1;
  if ($[0] !== hasSearchParams || $[1] !== onResetFilters || $[2] !== t) {
    t1 = hasSearchParams ? {
      description: t("tryRemovingFilters"),
      cta: {
        label: t("clearFilters"),
        onClick: onResetFilters
      }
    } : {
      description: t("discoverNewCollections"),
      cta: {
        label: t("goToDiscover"),
        href: "/"
      }
    };
    $[0] = hasSearchParams;
    $[1] = onResetFilters;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const props = t1;
  const t2 = !hasSearchParams;
  let t3;
  if ($[4] !== t) {
    t3 = t("noResultsFound");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ActivityFeedSkeleton overrides={{
      Header: {
        className: "!top-0"
      },
      Skeleton: {
        className: "animate-none"
      }
    }} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t2 || $[9] !== t3) {
    t5 = <EmptyStateStack showImageStack={t2} title={t3} {...props}>{t4}</EmptyStateStack>;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}